module.exports = __webpack_public_path__ + "img/thumb_31.2755e58e.jpg";